import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import axios from 'axios'
import './RegisterPage.css'

export default function RegisterPage({ onRegister }) {
  const { inviteCode } = useParams()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!inviteCode) {
      setError('No invite code provided. You need an invite to register.')
    }
  }, [inviteCode])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const response = await axios.post(
        '/api/auth/register',
        { invite_code: inviteCode, username, password, display_name: displayName },
        { withCredentials: true }
      )

      onRegister(response.data)
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <motion.div
      className="register-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="register-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="register-header">
          <h1 className="register-title">🎮 Join Ocean Daniel</h1>
          <p className="register-subtitle">Create your account</p>
        </div>

        <form className="register-form" onSubmit={handleSubmit}>
          {error && <div className="register-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="invite-code">Invite Code</label>
            <input
              id="invite-code"
              type="text"
              className="input"
              value={inviteCode || ''}
              disabled
            />
          </div>

          <div className="form-group">
            <label htmlFor="display-name">Display Name</label>
            <input
              id="display-name"
              type="text"
              className="input"
              placeholder="Your name"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              className="input"
              placeholder="Choose a username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              className="input"
              placeholder="Choose a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <motion.button
            type="submit"
            className="btn btn-primary btn-large"
            disabled={loading || !inviteCode}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {loading ? 'Creating Account...' : 'Create Account'}
          </motion.button>
        </form>

        <div className="register-footer">
          <p>Already have an account?</p>
          <a href="/login" className="register-link">
            Login here
          </a>
        </div>
      </motion.div>
    </motion.div>
  )
}
